// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ExternalLinkIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ExternalLink/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2H5Z"
}));
export default ExternalLinkIcon;